// extracted by mini-css-extract-plugin
export var tosLink = "_af-0";